export const environment = {
  production: true,
  serviceUrl: 'https://dev.service.ustechsupplierportal.com/',
  instance: 'LND'
};
